"use client";

import * as React from "react";
import {cn} from "../lib/utils";

interface SpinningIconProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  className?: string;
  size?: "sm" | "md" | "lg";
  speed?: "slow" | "normal" | "fast";
}

export function SpinningIcon({icon: Icon, className, size = "md", speed = "normal"}: SpinningIconProps) {
  // 偶数サイズを使用してサブピクセル問題を回避
  const sizeClasses = {
    sm: "w-4 h-4", // 16px - 偶数
    md: "w-6 h-6", // 24px - 偶数
    lg: "w-8 h-8", // 32px - 偶数
  };

  const animationStyle = {
    slow: {animation: "spin 2s linear infinite"},
    normal: {animation: "spin 1s linear infinite"},
    fast: {animation: "spin 0.5s linear infinite"},
  };

  // ラッパーdivに回転を適用（Lucide Reactで唯一確実に動作する方法）
  return (
    <div className={cn("inline-flex items-center justify-center", sizeClasses[size])} style={animationStyle[speed]}>
      <Icon className={cn(sizeClasses[size], className)} color="currentColor" strokeWidth={2} />
    </div>
  );
}
